<template>
  <v-container>
    <Loading v-if="isLoading" />
    <div v-html="html" v-else></div>
  </v-container>
</template>

<script setup lang="ts">
import Loading from "@/components/Widgets/Loading.vue";
import { useGlobalStore } from "@/stores/global";
import { convertMarkdownToHTML } from "@/utils";
import { computed, ref } from "vue";

const globalStore = useGlobalStore();

const html = computed(() => convertMarkdownToHTML(globalStore.contents.termsOfService || ""));
const isLoading = computed(() => globalStore.isContentsLoading);
</script>
